import styled,{css} from "styled-components";

export const Container = styled.div`
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5); 
    opacity: 0;
    z-index: -9;

    transition: opacity 0.3s ease, z-index 0.3s ease-in-out;

    display: flex;
    justify-content: center;
    align-items: center;

    position: fixed;
    top: 0;
    left: 0;

    ${props => props.isOpen && css`
        opacity: 1;
        z-index: 999;
    `}
`;

export const Content = styled.div`
    height: 95vh;
    width: 100%;
    opacity: 0;
    transform: translateY(5%);
    transition: transform 0.3s ease-out 0.2s, opacity 0.3s ease-out 0.2s;

    max-width: 768px;
    background: #FFF;

    border-radius: 5px;
    padding: 33px;
    box-shadow: rgb(0 0 0 / 46%) 0px 5px 10px;
    position: relative;

    display: flex;
    flex-direction: column;

    ${props => props.isOpen && css`
        transform: translateY(0);
        opacity: 1;
    `}

    overflow: scroll;
    ::-webkit-scrollbar{
        display: none;
    }

    @media (max-width: 768px) {
        height: 100%;
        border-radius: 0;
        padding: 20px;
    }
`;

export const Header = styled.header`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    margin-bottom: 0.5rem;

    h2{
        color: #393939;
    }

    button{
        background: transparent;
        border: none;
        font-size: 1.2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #393939;
    }
`;

export const Form = styled.div`
    width: 100%;
    margin-top: 2rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    
    button{
        margin: 2rem auto;
        width: 100%;
        height: 40px;
        background-color: #6E0496;
        color: #fff;
        border: 0;
        border-radius: 5px;
        font-size: 16px;
        font-weight: bold;
        cursor: pointer;
    }
`;

export const Input = styled.input`
    width: 100%;
    height: 40px;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    box-shadow: 0 2px 4px var(--colorShadow), 0 8px 16px var(--colorShadow);
    border: 1.5px solid gray;
    border-radius: 5px;

    font-weight: 500;
    font-size: 16px;
    padding: 0 10px;
`;

export const CoresContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 1rem;

    .color-container{
        width: 100%;
        margin-top: 1rem;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .color{
            width: 100px;
            display: flex;
            flex-direction: column;
            flex-direction: column-reverse;
            align-items: center;
            justify-content: center;

            label{
                text-align: center;
            }

            input{
                border: none;
                background: transparent;
                height: 3rem;
                width: 5rem;
                cursor: pointer;

                &::-webkit-color-swatch{
                    border-radius: 10px;
                    border: 2px solid #000;
                }
            }
        }
    }
`;